import { toaster } from "@hydrologiq/shared/chakra/Toaster"

export const showSuccessToast = (title: string, description?: string) => {
  toaster.create({
    title,
    description,
    type: "success",
    duration: 2000,
  })
}

export const showErrorToast = (title: string, description?: string) => {
  toaster.create({
    title,
    description,
    type: "error",
    duration: 4000,
  })
}

export const showLoadingToast = (title: string, description?: string) => {
  return toaster.create({
    title,
    description,
    type: "loading",
  })
}

export const showWarningToast = (title: string, description?: string) => {
  toaster.create({
    title,
    description,
    type: "warning",
    duration: 3000,
  })
}

export const dismissToast = (id?: string) => {
  if (id) {
    toaster.dismiss(id)
  } else {
    toaster.dismiss()
  }
}
